
export default function useIdToDate(id,content) {
  const target = content.find((e) => e.id === id);
  const date = target.date
  return { date };
}
